"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncIterableIncludes_ = asyncIterableIncludes_;

var _asyncLeadingWindow = require("../$leading-window/async-leading-window");

var _asyncToAnySubseq = _interopRequireDefault(require("../../internal/async-to-any-subseq"));

var _iterableStartsWith_ = require("../$starts-with_/iterable-starts-with_");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const startsWithConfig = {
  any: true,
  subseq: true
};

async function asyncIterableIncludes_(iterable, config, value) {
  const subseqs = await (0, _asyncToAnySubseq.default)(config, value);
  const maxMatchLength = subseqs.reduce((max, {
    length
  }) => Math.max(max, length), 1);
  let hasItems = false;

  for await (const buffer of (0, _asyncLeadingWindow.asyncLeadingWindow)(iterable, maxMatchLength)) {
    if ((0, _iterableStartsWith_.iterableStartsWith_)(buffer, startsWithConfig, subseqs)) {
      return true;
    }

    hasItems = true;
  }

  return !hasItems && !!subseqs.find(subseq => !subseq.length);
}